"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repayStakedBanx = void 0;
const common_1 = require("../../../../common");
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const anchor_1 = require("@project-serum/anchor");
const repayStakedBanx = ({ programId, connection, args, accounts, addComputeUnits, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const [bondProgramAuthority] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_PROOGRAM_AUTHORITY_PREFIX), accounts.fbond.toBuffer()], program.programId);
    const [collateralBox] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.COLLATERAL_BOX_PREFIX), accounts.fbond.toBuffer(), constants_1.ENCODER.encode('0')], program.programId);
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, accounts.collateralTokenMint);
    // const collateralTokenAccount = await findAssociatedTokenAddress(bondProgramAuthority, accounts.collateralTokenMint);
    const editionInfo = (0, helpers_1.getMetaplexEditionPda)(accounts.collateralTokenMint);
    const nftMetadata = (0, helpers_1.getMetaplexMetadata)(accounts.collateralTokenMint);
    const ownerTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.collateralTokenMint, accounts.collateralTokenAccount);
    const destTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.collateralTokenMint, userTokenAccount);
    const meta = yield mpl_token_metadata_1.Metadata.fromAccountAddress(connection, nftMetadata);
    const ruleSet = (_a = meta.programmableConfig) === null || _a === void 0 ? void 0 : _a.ruleSet;
    const repayRemainingAccounts = args.repayAccounts
        .map((repayAccount) => {
        return [
            {
                pubkey: repayAccount.bondTradeTransaction,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: repayAccount.user,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: repayAccount.bondOffer,
                isSigner: false,
                isWritable: true,
            },
        ];
    })
        .flat();
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const accountsIntoInstruction = {
        banxStake: accounts.banxStake,
        fbond: accounts.fbond,
        user: accounts.userPubkey,
        collateralBox: collateralBox,
        admin: accounts.admin,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
    };
    // console.log(
    //   'accounts: ',
    //   anchorRawBNsAndPubkeysToNumsAndStrings({ publicKey: hadoRegistry, account: accountsIntoInstruction }),
    // );
    instructions.push(yield program.methods
        .repayStakedBanx()
        .accountsStrict(accountsIntoInstruction)
        .remainingAccounts([...repayRemainingAccounts])
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const remainingAccounts = [
        ...repayRemainingAccounts.map((sellBondRemainingAccount) => sellBondRemainingAccount.pubkey),
    ];
    const addressesForLookupTable = [...Object.values(accountsIntoInstruction), ...remainingAccounts];
    const signers = [];
    yield sendTxn(transaction, signers);
    return { account: null, instructions, signers, addressesForLookupTable };
});
exports.repayStakedBanx = repayStakedBanx;
